import React from 'react';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';

const PLACEHOLDER_CATEGORIES = Array.from({ length: 8 }, (_, index) => index);

/**
 * Renders the loading placeholder for the service scraping section content,
 * mimicking the tabs, the analysis form and the category list.
 * @returns The placeholder layout for the service scraping section.
 */
const LoadingServiceScrapingSectionContent = () => (
    <div aria-hidden='true'>
        <div className='flex gap-20 padding-inline-20 border-color-bottom'>
            <LoadingPlaceholder variant='text' width={120} height={48} />
            <LoadingPlaceholder variant='text' width={90} height={48} />
        </div>
        <div className='hotel-presentation__section-controls --start'>
            <div className='hotel-presentation__competitor-searcher'>
                <LoadingPlaceholder
                    variant='rounded'
                    width='100%'
                    height={40}
                />
                <LoadingPlaceholder variant='text' width={260} height={20} />
            </div>
            <LoadingPlaceholder variant='rounded' width={120} height={40} />
        </div>
        <div className='flex gap-20 padding-top-20 padding-inline-20'>
            <LoadingPlaceholder variant='rounded' width={140} height={36} />
            <LoadingPlaceholder variant='rounded' width={150} height={36} />
        </div>
        <ul className='hotel-presentation__scraping-list'>
            {PLACEHOLDER_CATEGORIES.map(categoryIndex => (
                <li key={categoryIndex}>
                    <LoadingPlaceholder
                        variant='rounded'
                        width='100%'
                        height={42}
                    />
                </li>
            ))}
        </ul>
    </div>
);

export default LoadingServiceScrapingSectionContent;
